module.exports = {
      id: "illustrations:AU01-usage",
      viewBox: "0 0 272 238",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:AU01-usage",
      toString: function () {
        return this.url;
      }
    }